// extracted by mini-css-extract-plugin
export default {"animatedBackground":"DivContentLoader_animatedBackground__UgAlr","placeHolderShimmer":"DivContentLoader_placeHolderShimmer__M-FR4"};